import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgApexchartsModule } from 'ng-apexcharts';

import { CircleChartComponent } from './components/circle-chart/circle-chart.component';
import { DonutChartComponent } from './components/donut-chart/donut-chart.component';
import { DonutChartLegendComponent } from './components/donut-chart-legend/donut-chart-legend.component';
import { LineBarComponent } from './components/line-bar/line-bar.component';

@NgModule({
  imports: [CommonModule, NgApexchartsModule, DonutChartComponent, DonutChartLegendComponent, CircleChartComponent, LineBarComponent],
  exports: [DonutChartComponent, DonutChartLegendComponent, CircleChartComponent, LineBarComponent],
})
export class SharedChartsModule {}
